// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SignSuccessInfo_formContainer__17Pnk","warning":"SignSuccessInfo_warning__1onsT","underline":"SignSuccessInfo_underline__27jXY","btn":"SignSuccessInfo_btn__2sY6V"};